import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
// import SVG from 'react-inlinesvg'
import SVG from 'react-svg'

// Image with Mobile-Desktop-Switch
export interface ImageProps {
  // One Filename or Array with two Filenames (First is mobile, second Desktop)
  file?: string | [string, string]
  // className for the Image
  className?: string
  // Style-Properties for the Image
  css?: object
  // Folder of the Image default: "images/"
  folder?: string
  // Title to show above the Image
  title?: string
  // Subtitle to show below title
  subtitle?: string
  // Source to show below the image
  source?: string
}

const getFileType = (file: string) => {
  return file.slice(((file.lastIndexOf('.') - 1) >>> 0) + 2)
}

export const Image = ({
  file,
  className = 'viz',
  css = {},
  folder = 'images',
  title,
  subtitle,
  source
}: ImageProps) => {
  var fileType = ''
  var src = folder + '/'
  if (file) {
    if (typeof file === 'object') {
      if (browserCheck.isMobile) {
        src += file[0]
        fileType = getFileType(file[0])
      } else {
        src += file[1]
        fileType = getFileType(file[1])
      }
    } else {
      src += file
      fileType = getFileType(file)
    }
  } else {
    return (
      <>
        {title && <div className='imageTitle'>{title}</div>}
        {subtitle && <div className='imageSubtitle'>{subtitle}</div>}
        <img
          src={require('./' + 'assets/imagePlaceholder.png')}
          className={className}
          style={css}
        />
        {source && <div className='imageSource'>{source}</div>}
      </>
    )
  }
  // console.groupCollapsed('Image')
  // console.log('SRC', src)
  // console.log('TYPE', fileType)
  // console.groupEnd()
  // let isIE = /*@cc_on!@*/false || !!document.documentMode;

  const isEdge = window.navigator.userAgent.indexOf('Edge') !== -1
  const isIE = window.navigator.userAgent.indexOf('Trident') !== -1 && !isEdge
  // console.log('IE: ' + isIE + ' | Edge:' + isEdge)

  return (
    <>
      {title && <div className='imageTitle'>{title}</div>}
      {subtitle && <div className='imageSubtitle'>{subtitle}</div>}
      {fileType === 'svg' ? (
        isIE || isEdge ? (
          <img
            src={src.replace('.svg', '.png')}
            className={className}
            style={css}
          />
        ) : (
          <SVG src={src} className={className} style={css} />
        )
      ) : (
        <img src={src} className={className} style={css} />
      )}
      {source && <div className='imageSource'>{source}</div>}
    </>
  )
}
